import { FC, Ref } from 'react';

import { BottomSheet } from '../../BottomSheet';
import { Modal, ModalProps } from '../../Modal';
import { useMedia } from '../../useMedia';

import ResponsiveDialogBody from './ResponsiveDialogBody/ResponsiveDialogBody';
import ResponsiveDialogClose from './ResponsiveDialogClose/ResponsiveDialogClose';
import ResponsiveDialogFooter from './ResponsiveDialogFooter/ResponsiveDialogFooter';
import ResponsiveDialogHeader from './ResponsiveDialogHeader/ResponsiveDialogHeader';
import { DIALOG_DESKTOP_QUERY } from './query';

export type ResponsiveDialogProps = Omit<ModalProps, 'ref'> & {
  /** Показывать ли ручку мобильной шторки. Не меняет способы закрытия; на десктопе игнорируется. */
  showHandle?: boolean;
  /** Ref на окно или шторку (контент диалога). */
  ref?: Ref<HTMLDivElement>;
};

/** Modal на десктопе, BottomSheet на мобайле — переключается по DIALOG_DESKTOP_QUERY из useMedia. */
const ResponsiveDialog: FC<ResponsiveDialogProps> = ({ width, showHandle, ...rest }) => {
  const isDesktop = useMedia(DIALOG_DESKTOP_QUERY);

  return isDesktop ? (
    <Modal
      width={width}
      {...rest}
    />
  ) : (
    <BottomSheet
      showHandle={showHandle}
      {...rest}
    />
  );
};

type ResponsiveDialogCompound = typeof ResponsiveDialog & {
  Header: typeof ResponsiveDialogHeader;
  Body: typeof ResponsiveDialogBody;
  Footer: typeof ResponsiveDialogFooter;
  Close: typeof ResponsiveDialogClose;
};

const CompoundResponsiveDialog = ResponsiveDialog as ResponsiveDialogCompound;
CompoundResponsiveDialog.Header = ResponsiveDialogHeader;
CompoundResponsiveDialog.Body = ResponsiveDialogBody;
CompoundResponsiveDialog.Footer = ResponsiveDialogFooter;
CompoundResponsiveDialog.Close = ResponsiveDialogClose;

export default CompoundResponsiveDialog;
